enum TextType {
  BOLD = "bold",
  ITALIC = "italic",
  STRIKE = "strike",
  UNDERLINE = "underline",
}

export default TextType;
